export const ADD_ROUTE = 'ADD_ROUTE';
export const DELETE_ROUTE = 'DELETE_ROUTE';
export const LOAD_ROUTES = 'LOAD_ROUTES';
export const ADD_COST = 'ADD_COST';
export const SUBTRACT_COST = 'SUBTRACT_COST';
export const ADD_HOME = 'ADD_HOME';
export const SUBTRACT_HOME = 'SUBTRACT_HOME';
export const ACTIVE_ROUTE = 'ACTIVE_ROUTE';
export const DEACTIVE_ROUTE = 'DEACTIVE_ROUTE';
export const CLEAR_TABLE = 'CLEAR_TABLE';
export const CONTROL_COLLAPSE = 'CONTROL_COLLAPSE';
export const ADD_BUSINESS = 'ADD_BUSINESS';
export const SUBTRACT_BUSINESS = 'SUBTRACT_BUSINESS';
export const EXCLUDED_BUSINESS = 'EXCLUDED_BUSINESS';
export const HOVERED_ROUTE = 'HOVERED_ROUTE';
export const UNHOVERED_ROUTE = 'UNHOVERED_ROUTE';
export const RESET_SELECTED_ROUTES = 'RESET_SELECTED_ROUTES';